// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UQXB2civve6o5gaC9bVY {

    margin: 1.25rem
}

.sn1ne7qhosD7Y6pyW52Y {

    display: grid;

    grid-template-columns: repeat(1, minmax(0, 1fr));

    gap: 1rem;

    padding-bottom: 1.75rem
}

@media (min-width: 1024px) {

    .z8UbDcKyP8qaRUw056PD {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }

    .D5BQ9JA8tOnoazRgRJ1g {

        grid-template-columns: repeat(1, minmax(0, 1fr))
    }
}

.I3IqVNpaoaPz_wGQkUi2 {

    margin-top: 0.75rem;

    display: grid;

    grid-template-columns: repeat(1, minmax(0, 1fr));

    gap: 1rem
}
`, "",{"version":3,"sources":["webpack://./src/pages/PledgeConsentApproval/components/ConsentDetails/ConsentDetails.module.css"],"names":[],"mappings":"AACE;;IAAA;AAAU;;AAIV;;IAAA,aAAkC;;IAAlC,gDAAkC;;IAAlC,SAAkC;;IAAlC;AAAkC;;AAIlC;;IAAA;;QAAA;IAAqB;;IAIrB;;QAAA;IAAqB;AAJA;;AAQrB;;IAAA,mBAAkC;;IAAlC,aAAkC;;IAAlC,gDAAkC;;IAAlC;AAAkC","sourcesContent":[".container {\n  @apply m-5;\n}\n\n.customerGrid {\n  @apply grid gap-4 grid-cols-1 pb-7;\n}\n\n.customerGridWithOwner {\n  @apply lg:grid-cols-2;\n}\n\n.customerGridWithoutOwner {\n  @apply lg:grid-cols-1;\n}\n\n.pledgeGrid {\n  @apply grid grid-cols-1 gap-4 mt-3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UQXB2civve6o5gaC9bVY`,
	"customerGrid": `sn1ne7qhosD7Y6pyW52Y`,
	"customerGridWithOwner": `z8UbDcKyP8qaRUw056PD`,
	"customerGridWithoutOwner": `D5BQ9JA8tOnoazRgRJ1g`,
	"pledgeGrid": `I3IqVNpaoaPz_wGQkUi2`
};
export default ___CSS_LOADER_EXPORT___;
